import React, { useState } from 'react';
import { IoShareOutline } from 'react-icons/io5';
import { FeedbackMessage } from '../FeedbackMessage/FeedbackMessage'; // Import the new component
import './ShareButton.css';

export function ShareButton({ clip, size = "40px", color = "#D9D9D9" }) {
    const [feedbackMessage, setFeedbackMessage] = useState('');

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            setFeedbackMessage('Clip copied!');
        } catch (error) {
            setFeedbackMessage('Failed to copy!');
        }
    };

    const handleClick = async (event) => {
        event.stopPropagation(); // Stop the event from bubbling up to parent elements

        const shareLink = `${window.location.origin}/focus/${clip.id}`;

        if (navigator.share) {
            try {
                await navigator.share({
                    title: `Check out this Lavalamp clip: ${clip.title}`,
                    url: shareLink,
                });
            } catch (error) {
                console.error('Error sharing:', error);
            }
        } else {
            // Fallback for browsers that do not support the Web Share API
            copyToClipboard(shareLink);
        }
    };

    return (
        <>
            <button
                onClick={handleClick}
                className="shareButton"
            >
                <IoShareOutline color={color} size={size} strokeWidth={5} />
            </button>
            <FeedbackMessage message={feedbackMessage} onClear={() => setFeedbackMessage('')} />
        </>
    );
}
